import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { COPYRIGHT } from "../../components/Layout/AppLayout";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const notice    = (useLocation().state as { message?: string } | null)?.message;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/");
    } catch (err: unknown) {
      setError(
        (err as { response?: { data?: { error?: { message?: string } } } })
          ?.response?.data?.error?.message ?? "حدث خطأ، يرجى المحاولة مجدداً"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-sand-100">
      <div className="card accent-top w-[420px] max-w-full !p-10 shadow-login">
        <div className="text-center mb-8">
          <div className="inline-flex w-16 h-16 rounded-full bg-sand-100 items-center justify-center mb-4">
            <img src="/logo.png" alt="" className="w-16 h-16 object-contain" />
          </div>
          <h1 className="text-xl font-bold text-gray-900">وزارة الدفاع</h1>
          <p className="text-[13px] text-sand-500 mt-1">الإدارة العامة — طلبات وجبات الطعام</p>
        </div>

        {notice && !error && <div className="alert-success mb-4">{notice}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="label" htmlFor="username">اسم المستخدم</label>
            <input id="username" type="text" className="input" dir="ltr" style={{ textAlign: "right" }}
              value={username} onChange={(e) => setUsername(e.target.value)}
              placeholder="أدخل اسم المستخدم" autoComplete="username" required />
          </div>
          <div>
            <label className="label" htmlFor="password">كلمة المرور</label>
            <input id="password" type="password" className="input" dir="ltr" style={{ textAlign: "right" }}
              value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة المرور" autoComplete="current-password" required />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full !py-3.5 !text-[15px]">
            {loading ? "جاري الدخول..." : "تسجيل الدخول"}
          </button>
        </form>

        {error && <div className="alert-error mt-4">{error}</div>}
      </div>

      <p className="text-center text-sand-500 text-xs mt-6">{COPYRIGHT}</p>
    </div>
  );
}
